module.exports = __webpack_public_path__ + "img/calendar-day.ba2e75eb.svg";